export default function isStatus(
  statuses,
  record,
  recordField,
  ...expectations
) {
  return (
    !!record &&
    expectations.map((name) => statuses[name]).includes(record[recordField])
  );
}
